import axios from 'axios';
import TokenStorage from '../TokenStorage';

const baseUrl = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(config => {
    config.headers.common['Authorization'] = TokenStorage.getToken(TokenStorage.TYPE_ID);
    return config;
});

export default class Base {
    constructor(props) {
        this.props = props;
        this.useBase = true;
    }

    raw = () => {
        this.useBase = false;
        return this;
    }

    get = (url) => {
        return axios.get(this.buildUrl(url))
            .then(this.successHandler)
            .catch(this.errorHandler);
    };

    post = (url, data) => {
        return axios.post(this.buildUrl(url), data)
            .then(this.successHandler)
            .catch(this.errorHandler)
    }

    patch = (url, data) => {
        return axios.patch(this.buildUrl(url), data)
            .then(this.successHandler)
            .catch(this.errorHandler)
    }

    put = (url, data) => {
        return axios.put(this.buildUrl(url), data)
            .then(this.successHandler)
            .catch(this.errorHandler)
    }

    delete = (url) => {
        return axios.delete(this.buildUrl(url))
            .then(this.successHandler)
            .catch(this.errorHandler)
    }

    tries = 0;

    retry = (config) => {
        if (!this.error) {
            return;
        }

        if (this.error.response && this.error.response.status === 401) {
            this.tries++
            if (this.tries > 2) {
                return;
            }

            this.useBase = true;
            const token = TokenStorage.getToken(TokenStorage.TYPE_REFRESH);
            this.post('/users/auth/refresh', { token: token })
                .then(res => {
                    TokenStorage.setToken(TokenStorage.TYPE_ID, res.data.data.id_token);
                    TokenStorage.setToken(TokenStorage.TYPE_REFRESH, res.data.data.refresh_token);
                    this.tries = 0;
                    if (config.params) {
                        return config.cb(...config.params)
                    }
                    config.cb();
                    
                })
                .catch(err => {
                    if (err.response && err.response.status === 401) {
                        TokenStorage.removeToken(TokenStorage.TYPE_ID);
                        TokenStorage.removeToken(TokenStorage.TYPE_REFRESH);
                        if (this.props && this.props.history) {
                            this.props.history.push('/');
                        }
                    }
                });
        }
    }

    successHandler = (res) => {
        this.useBase = true;
        return res;
    }

    errorHandler = (err) => {
        if (err.response && this.props && this.props.history) {
            if (err.response.status === 402) {
                this.props.history.push('/profile/payment');
                return;
            } else if (err.response.status === 404) {                
                this.props.history.push('/404');
                return;
            }
        }
        
        this.error = err;
        throw err; 
    }

    buildUrl = (url) => {
        return this.useBase ? baseUrl + url : url;
    }
}


// WEBPACK FOOTER //
// ./src/services/api/Base.js